export const FEATURE_DISPLAY_TEXTS: Record<string, string> = {
  mainDwelling: 'Main Dwelling',
  garage: 'Garage',
  carport: 'Carport',
  porch: 'Porch',
  patio: 'Patio',
  deck: 'Deck',
  workshop: 'Workshop',
  shed: 'Shed',
  barn: 'Barn',
  pool: 'Pool',
  spa: 'Spa',
  adu: 'ADU',
  fireplace: 'Fireplace',
  manualCost: 'Manual Cost',
};
